module.exports = __webpack_public_path__ + "static/media/Atendimento_Iniciado.4c993e60.svg";